<template>
  <fragment>
    <div v-for="item in itemsTree" :key="item.id || item.uuid" class="composite-item mt-20">
      <component
        v-if="item"
        :is="components[item.type]"
        :questionData="item"
        :color="color"
        :lang="lang"
        :onSelectAnswer="onSelectAnswer"
        :style="{ fontWeight: children ? 300 : 600 }"
        composite
      />
      <CompositMetricTree
        v-if="item.items && item.items.length > 0"
        :itemsTree="item.items"
        :color="color"
        :lang="lang"
        :onSelectAnswer="onSelectAnswer"
        children
        :answer="answer"
        :parentType="parentType"
      />
    </div>
  </fragment>
</template>
<script>
import CompositMetricTree from "./CompositeMetricTree";
import ThumbsComposite from "./ThumbsComposite";
import TitleComposite from "./Title";
export default {
  name: "CompositMetricTree",
  components: { CompositMetricTree, ThumbsComposite, TitleComposite },
  props: {
    itemsTree: Array,
    lang: {
      type: String,
      default: "pt_BR"
    },
    color: {
      type: String
    },
    onSelectAnswer: {
      type: Function,
      default: () => {}
    },
    children: Boolean,
    answer: Number,
    parentType: Number
  },
  data() {
    return {
      components: {
        [this.$consts.QUESTION_TYPE.LABEL]: "TitleComposite",
        [this.$consts.QUESTION_TYPE.THUMBS]: "ThumbsComposite"
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.composite-item .composite-item {
  padding-left: 12px;
}
</style>
